import { useCallback, useEffect, useState } from 'react';

export function useLoadMore(fetchMore, data, variables) {
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [currentOffset, setCurrentOffset] = useState(0);
  const list = data?.list?.entities;

  useEffect(() => {
    setCurrentOffset(list?.length || 0);
  }, [list?.length]);

  const loadMore = useCallback(() => {
    setIsLoadingMore(true);

    fetchMore({
      variables: {
        ...variables,
        input: {
          ...variables.input,
          offset: currentOffset,
        },
      },
    }).finally(() => setIsLoadingMore(false));
  }, [setIsLoadingMore, fetchMore, variables, currentOffset]);

  return { isLoadingMore, loadMore, currentOffset };
}
